import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-ng-for-business',
  templateUrl: './ng-for-business.component.html',
  styleUrls: ['./ng-for-business.component.scss'],
})
export class NgForBusinessComponent {
  windowWidth$: Observable<number> = fromEvent(window, 'resize').pipe(
    map(() => window.innerWidth),
    startWith(window.innerWidth)
  );
}
